import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SUBMISSION_REVIEW_ACTIONS } from '../actions/submissions.actions';
import { ReviewHold } from '@submissions/v1/models/submission.model';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable()
export class SubmissionReviewFacadeService {
  private readonly _store = inject(Store);

  openReviewDialog(
    data: ReviewHold[],
    dialogComponent: ComponentType<unknown>,
  ) {
    this._store.dispatch(
      SUBMISSION_REVIEW_ACTIONS.openSubmissionReviewDialog({
        component: () => dialogComponent,
        data,
      }),
    );
  }
}
